/* import __COLOCATED_TEMPLATE__ from './procedure-list-item-stats.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

interface ProcedureListItemStatsSignature {
  Args: {
    procedureId: string;
  };
  Element: HTMLDivElement;
}

// Mapping of stat types to their corresponding metric IDs
const STAT_TO_METRIC_ID: Record<string, string> = {
  triggered: 'fin.conversations_participated.count',
  resolved: 'fin.resolution_rate',
  handoff: 'fin.procedure_handoff_rate',
  escalated: 'fin.routed_to_team_rate',
};

type StatType = 'triggered' | 'resolved' | 'handoff' | 'escalated';

export default class TasksProcedureListItemStats extends Component<ProcedureListItemStatsSignature> {
  @service declare permissionsService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;

  @tracked selectedProcedureId?: string;
  @tracked selectedStat?: StatType;

  drillInColumns = [
    'conversation.id',
    'conversation.first_user_conversation_part_created_at',
    'conversation.fin.resolution_state',
    'conversation.channel_type',
    'conversation.bot_conversation_rating.rating_index',
    'conversation.fin.procedures_triggered.procedure_ids',
  ];
  get chartDefinitions(): Record<string, any> {
    return {
      triggered: this.chartDefinitionForStat('triggered'),
      resolved: this.chartDefinitionForStat('resolved'),
      handoff: this.chartDefinitionForStat('handoff'),
      escalated: this.chartDefinitionForStat('escalated'),
    };
  }

  @action
  openSideDrawer(procedureId: string, stat: StatType, event: Event) {
    this.trackEvent(stat);
    event.stopPropagation();
    event.preventDefault();
    if (this.permissionsService.currentAdminCan('can_reporting__drillin__access')) {
      this.selectedProcedureId = procedureId;
      this.selectedStat = stat;
    } else {
      this.permissionsService.loadAllAdminsAndShowPermissionRequestModal(
        'can_reporting__drillin__access',
      );
    }
  }

  @action
  closeSideDrawer() {
    this.selectedProcedureId = undefined;
    this.selectedStat = undefined;
  }

  @action
  trackEvent(stat_clicked: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'procedure_stat',
      place: 'procedure_list_item',
      section: 'procedures',
      stat: stat_clicked,
    });
  }

  private chartDefinitionForStat(stat: string): any {
    let procedureId = this.args.procedureId;
    let metricId = STAT_TO_METRIC_ID[stat];

    if (!metricId) {
      throw new Error(`Invalid stat: ${stat}`);
    }

    return {
      id: `procedure_${procedureId}_${stat}`,
      visualization_type: 'counter',
      chart_series: [
        {
          metric_id: metricId,
          filters: {
            type: 'and',
            filters: [
              {
                type: 'category',
                data: {
                  property: 'fin.procedures_triggered.procedure_ids',
                  values: [procedureId],
                },
              },
            ],
          },
        },
      ],
    };
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Tasks::ProcedureListItemStats': typeof TasksProcedureListItemStats;
  }
}
